import script from "./tablist.vue?vue&type=script&setup=true&lang=ts"
export * from "./tablist.vue?vue&type=script&setup=true&lang=ts"

import "./tablist.vue?vue&type=style&index=0&id=b61e8498&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b61e8498"]])

export default __exports__